<template>
  <div class="mb-5">
    <div>
      <campaign-stat-section-heading
        title="Interest Indicators"
        description="Total number of available actions taken on your website to 'learn more'"
        :loading="loading"
      ></campaign-stat-section-heading>
    </div>
    <div class="stat-items-container" v-if="hasData">
      <stat-item-card
        v-if="soiViews"
        :value="soiViews"
        label="SOI Views"
        tooltip="The number of times the Statement of Information has been downloaded"
      ></stat-item-card>

      <stat-item-card
        v-if="imageViews"
        :value="imageViews"
        label="Image Views"
        tooltip="Total number of times listing imagery was viewed across all media channels"
      ></stat-item-card>

      <stat-item-card
        v-if="videoViews"
        :value="videoViews"
        label="Video Views"
        tooltip="The number of clicks to view the video"
      ></stat-item-card>

      <stat-item-card
        v-if="floorplanViews"
        :value="floorplanViews"
        label="Floorplan Views"
        tooltip="The number of clicks to view the floorplan across all media channels"
      ></stat-item-card>

      <stat-item-card
        v-if="inspectionAuctionLocationViews"
        :value="inspectionAuctionLocationViews"
        label="Inspection - Auction - Location Views"
        tooltip="The number of clicks to view the floorplan across all media channels"
      ></stat-item-card>

      <stat-item-card
        v-if="websiteLiveChat"
        :value="websiteLiveChat"
        label="Website Live Chat"
        tooltip="Buyer engagement via live chat with GaiLE virtual property"
      ></stat-item-card>

    </div>
    <no-stat-data-available
      v-if="!hasData && !loading"
      sectionTitle="interest indicators"
    ></no-stat-data-available>
  </div>
</template>
<script>
import StatItemCard from './StatItemCard.vue';
import CampaignStatSectionHeading from './CampaignStatSectionHeading.vue';
import NoStatDataAvailable from './NoStatDataAvailable.vue';
export default {
  props: [
    'soiViews',
    'imageViews',
    'videoViews',
    'websiteLiveChat',
    'floorplanViews',
    'inspectionAuctionLocationViews',
    'loading'
  ],
  components: {
    StatItemCard,
    CampaignStatSectionHeading,
    NoStatDataAvailable,
  },
  computed: {
    hasData() {
      if (this.loading) return false;

      return this.soiViews || this.imageViews || this.videoViews || this.websiteLiveChat || this.floorplanViews || this.inspectionAuctionLocationViews;
    },
  },
};
</script>

<style>
.stat-items-container {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 24px;
}
</style>
